
import {
  isKeypressEnter,
  isKeypressSpace,
  isKeypressLeftArrow,
  isKeypressRightArrow,
} from '~/helpers/accessibility'
import LoleH1 from '~/components/text/lole-h1.vue'
import LoleH3 from '~/components/text/lole-h3.vue'
import LoleBtn from '~/components/buttons/lole-btn.vue'
import LolePicture from '~/components/picture/lole-picture'
import LoleP from '~/components/text/lole-p.vue'
import LoleSizeTable from '~/components/size-guide/lole-size-table.vue'
export default {
  components: { LoleH1, LoleH3, LoleBtn, LolePicture, LoleP, LoleSizeTable },
  props: {
    content: {
      type: Object,
      required: true,
    },
    defaultOpeningIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    tableInch: true,
    level_1_toShow: 0,
    level_2_toShow: 0,
  }),
  mounted() {
    if (this.defaultOpeningIndex) this.level_1_toShow = this.defaultOpeningIndex
  },
  methods: {
    getLevel1(index) {
      return this.content.level_1[index]
    },
    getListLevel2(indexLevel1) {
      return this.content.level_1[indexLevel1]?.level_2.filter(
        ({ disabled }) => {
          return !disabled
        }
      )
    },
    selectLevel1(index) {
      this.level_2_toShow = 0
      this.level_1_toShow = index
    },
    handleKeydown(event) {
      if (
        !isKeypressEnter(event) &&
        !isKeypressSpace(event) &&
        !isKeypressLeftArrow(event) &&
        !isKeypressRightArrow(event)
      )
        return

      let currentElement = this.$refs[event.target.id]
      let targetElement = null

      if (!currentElement) return

      if (Array.isArray(currentElement)) {
        currentElement = currentElement[0].$el || currentElement[0]
      }

      if (isKeypressEnter(event) || isKeypressSpace(event) === 32) {
        currentElement.click()
      }

      if (isKeypressLeftArrow(event)) {
        // LEFT ARROW

        targetElement = currentElement.previousElementSibling
          ? this.$refs[currentElement.previousElementSibling.id]
          : null
      } else if (isKeypressRightArrow(event)) {
        // RIGHT ARROW

        targetElement = currentElement.nextElementSibling
          ? this.$refs[event.target.nextElementSibling.id]
          : null
      }

      if (Array.isArray(targetElement)) {
        targetElement = targetElement[0].$el || targetElement[0]
      }

      if (targetElement && targetElement.tabIndex === -1) {
        currentElement.tabIndex = -1
        targetElement.tabIndex = 0
        targetElement.focus()
      }
    },
  },
}
